import React from "react";
import { Modal, Table } from "react-bootstrap";

const ConversionHistoryModal = ({ show, onHide, data }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-clock-history text-info me-2"></i>
          Conversion History - {data?.barcode}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data?.conversionHistory && data.conversionHistory.length > 0 ? (
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead className="table-info">
                <tr>
                  <th>#</th>
                  <th>Version</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.conversionHistory.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <span className="badge bg-primary">{item.version}</span>
                    </td>
                    <td>
                      <span
                        className={`fw-bold ${
                          item.from === "Sale"
                            ? "text-success"
                            : item.from === "Rent"
                            ? "text-danger"
                            : "text-muted"
                        }`}
                      >
                        {item.from || "Initial(Sale)"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`fw-bold ${
                          item.to === "Sale"
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {item.to}
                      </span>
                    </td>
                    <td>{item.startDate}</td>
                    <td>
                      {item.endDate ? (
                        item.endDate
                      ) : (
                        <span className="badge bg-success">Active</span>
                      )}
                    </td>
                    <td>
                      {!item.endDate ? (
                        <i className="bi bi-check-circle-fill text-success fs-5"></i>
                      ) : (
                        <i className="bi bi-x-circle-fill text-secondary fs-5"></i>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center p-4">
            <i className="bi bi-inbox fs-1 text-muted"></i>
            <p className="text-muted mt-2">No conversion history available</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConversionHistoryModal;